import React, { Component, createRef } from "react";
import "component/listItem/CategoryType1/styles.scss";
import iconDefault from "assets/images/iconDefault.png";
import { setDefaultImageFormat } from "utils/image";
import { getTotalPool } from "utils/getTotalpool";


class CategoryType1 extends Component {
  constructor(props) {
    super(props);
    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.mainComponent = createRef();
    this.iconDefaultRef = createRef();
    this.state = {
      hovered: false,
      isVisible: false,
      hasPromotionIcons: false,
      jackpotPool: null,
    };
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  componentDidMount() {
    this.initObserver();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.game && nextProps.game !== this.props.game) {
      let hasPromotionIcons;
      nextProps.game.get("hasFreeRounds") ||
        nextProps.game.get("partOfOnGoingTournament") ||
        nextProps.game.get("isFeatured");
      this.setState({
        hasPromotionIcons,
      });
    }

    if (
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.game.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.mainComponent.current) {
                this.setState({
                  isVisible: true,
                });
              }
            } else {
              if (this.mainComponent.current) {
                //clearInterval(this.initLoadDelay)
              }
            }
          });
        },
        {
          //rootMargin: '500px 0px 500px 0px'
          rootMargin: "0px 0px 0px 0px",
        }
      );
      observer.observe(this.mainComponent.current);
    } else {
      //this.getGames(this.props.link);
      //this.getTournamentPreview(this.props.links)
    }
  }

  renderSkeleton() {
    return (
      <div>
        <img src={iconDefault} className="icon" alt="name" />
        <div className="details">
          <div className="name">
            <span className="dummy">XXXXXXX</span>
          </div>
          <div className="provider">
            <span className="dummy">XXXXXXXX</span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { game } = this.props;

    return (
      <div
        className={`${this.props.className} category-type-1`}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={(event) => {
          if (this.props.onClick) {
            this.props.onClick(this.props.linkDetails.get("rel"));
          }
          event.stopPropagation();
        }}
        ref={this.mainComponent}
      >
        {!game && this.renderSkeleton()}
        {game && (
          <div>
            {game && game.get("jackpotBalance") && (
              <div className="jackpot-amount">
                {this.getTotalPool(this.state.jackpotPool, game, false)}
              </div>
            )}
            {this.state.isVisible && (
              <img
                src={`${setDefaultImageFormat(
                  game
                    .getIn(["images", "url"])
                    .replace("width=90", "width=200") + "&theme=dark",
                  this.props.imageFormat.get("logoRound")
                )}`}
                className="icon"
                alt={game.get("name")}
                onLoad={({ currentTarget }) => {
                  currentTarget.classList.remove("d-none");
                  this.iconDefaultRef.current.classList.add("d-none");
                }}
              />
            )}
            <img
              ref={this.iconDefaultRef}
              src={iconDefault}
              className="icon"
              alt={game.get("name")}
            />
            <div className="details">
              <div className="name">{game.get("name")}</div>
              <div className="provider">{game.get("provider")}</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CategoryType1;
